export default [
  {// 列表页
    path: '/standard-library',
    name: 'standardLibrary',
    component: () => import("../views/standardLibrary/standardLibrary.vue"),
    meta: {
      title:'标准列表',
      requireAuth: true
    },
  },
  {// 标准详情
    path: '/standard-detail',
    name: 'standardDetail',
    component: () => import("../views/standardLibrary/standardDetail.vue"),
    meta: {
      title:'标准详情',
      requireAuth: true
    },
  },
  {// 我的收藏
    path: '/my-collect',
    name: 'myCollect',
    component: () => import("../views/standardLibrary/myCollect.vue"),
    meta: {
      title:'我的收藏',
      requireAuth: true
    },
  }
]